module.exports = __webpack_public_path__ + "media/images/wowu_logo-130220c061f395c2c829325aed20a07a.svg";